import loadable from '@loadable/component';
import { WithLazyHydration } from '../WithLazyHydration';

const ExpandedSearchLoadable = loadable(() => import('./ExpandedSearch'), {
  resolveComponent: components => components.ExpandedSearch
});

export const ExpandedSearch = WithLazyHydration(ExpandedSearchLoadable, {
  name: 'ExpandedSearch'
});
